import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Add this to your imports
import { UpdateCanCreateEpin, UpdateCanCreateBlog, GetById } from '../../service/UserService';

export default function MemberEdit() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  //read id from useParams
  const { id } = useParams();

  const [canCreateEpin, setCanCreateEpin] = useState('0');
  const [canCreateBlog, setCanCreateBlog] = useState('0');
  const [user, setUser] = useState({});
  const [status, setStatus] = useState('active');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    console.log(file);
  };

  const fetchUserById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setUser(response.user);
        setName(response.user.name);
        setEmail(response.user.email);
        setMobile(response.user.mobile);
        setImage(response.user.image);
        setStatus(response.user.status);
        setCanCreateEpin(response.user.canCreateEpin ? '1' : '0');
        setCanCreateBlog(response.user.canCreateBlog ? '1' : '0');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  const saveMember = async (event) => {
    event.preventDefault();

    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const epinResponse = await UpdateCanCreateEpin(id, canCreateEpin);
      const blogResponse = await UpdateCanCreateBlog(id, canCreateBlog);

      if (epinResponse.status === 200 || blogResponse.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(epinResponse.message || blogResponse.message || "Member Successfully Updated");
        setAppErrorMode("success");
        // Redirect based on status        
        window.location.href = "/members/permission/" + id;        
      } else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(epinResponse.message || blogResponse.message || "Failed to update member. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to update member. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchUserById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Member Manage | {config.appName}</title>
      </Helmet>

      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Manage Member Permissions</h1>
            <span>
              {status === 'active' && (
                <>
                  <Link to="/">Dashboard</Link> /{" "}
                  <Link to="/members/list"> Active Member List</Link> / Member Manage
                </>
              )}
            </span>

          </div>

          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <form onSubmit={saveMember} encType='multipart/form-data'>
                  <div className="row">

                    <div className='col-lg-1 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        {user?.id && user?.image && (
                          <img
                            src={`${config.imageBasePath}/user/${user.id}.${user.image}`}
                            alt={user.name}
                            className='img-fluid image-xs'
                            style={{ width: '100px', marginTop: '10px', height: '55px' }}
                          />
                        )}
                      </div>
                    </div>
                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          className='form-control'
                          type='text'
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Mobile</label>
                        <input
                          className='form-control'
                          type='number'
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className='col-lg-5 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          className='form-control'
                          type='email'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Can Create Epin ?</label>
                        <br></br>
                        <input type='radio' name='canCreateEpin' value="1" onChange={(e) => setCanCreateEpin(e.target.value)} checked={canCreateEpin === '1'} /> Yes &nbsp;&nbsp;
                        <input type='radio' name='canCreateEpin' value="0" onChange={(e) => setCanCreateEpin(e.target.value)} checked={canCreateEpin === '0'} /> No
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Can Create Blog ?</label>
                        <br></br>
                        <input type='radio' name='canCreateBlog' value="1" onChange={(e) => setCanCreateBlog(e.target.value)} checked={canCreateBlog === '1'} /> Yes &nbsp;&nbsp;
                        <input type='radio' name='canCreateBlog' value="0" onChange={(e) => setCanCreateBlog(e.target.value)} checked={canCreateBlog === '0'} /> No
                      </div>
                    </div>

                    <div className='clearfix'></div>
                    <div className='col-12 text-end'>
                      <div className="mb-3">
                        <button type='reset' className='btn btn-danger btn-md'>
                          <i className="ri-reset-right-line"></i> Reset
                        </button>
                        &nbsp;&nbsp;
                        <button type='submit' className='btn btn-success btn-md'>
                          <i className="ri-check-fill"></i> Update Member
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};